import { createPinia } from "pinia";
const piana = createPinia();
export default piana;
